import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { ORDER, SOURCE, ORDER_DETAILS, CART_FOR_ORDER } from './types';
import { source, order, purchaseOrderNumber, cartByOrderNumber } from '../../api';

export const fetchSource = (sourceParam: string) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const sourceData = source(sourceParam, state);
  dispatch(thunkProgress(SOURCE, sourceData));
};

export const fetchOrder = (orderId: string) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const orderData = order(orderId, state);
  dispatch(thunkProgress(ORDER, orderData));
};

export const fetchPurchaseOrderNumber = (orderId: string, purchaseOrderNumberParam: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const purchaseData = purchaseOrderNumber(orderId, purchaseOrderNumberParam, state);
  dispatch(thunkProgress(ORDER_DETAILS, purchaseData));
};

export const fetchCartByOrderNumber = (orderId: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();
  const purchaseData = cartByOrderNumber(orderId, state);
  dispatch(thunkProgress(CART_FOR_ORDER, purchaseData));
};
